import React from 'react'
import dataFiscal from '../../imagenes/footer/data-fiscal.jpg'
import dataFiscal2 from '../../imagenes/footer/data-fiscal-2.jpg'
import mundin from '../../imagenes/logo/mundin-tele.png'
import iata from '../../imagenes/footer/iata.png'
import { withRouter } from 'react-router-dom'

const SubFooter = (props) => {
  const { location } = props || {};
  const { pathname = '' } = location || {}

  return (
      <div className={`copy ${pathname.includes('/hoteles') ? 'cdrColor' : ''}`}>
          <div className="container">
            <ul className="row">
              <li className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 text-center">
                <h6><i className="material-icons" style={{fontSize: '16px'}}>location_on</i>Buenos Aires</h6>
                <p>Florida 537. Piso 8° CABA. Bs. As.</p>
                <p>Tel.: 011-4105-2100 / 4131-5300</p>
              </li>
              <li className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 text-center">
                <img src={mundin} alt="Mundin al telefono" width="74" height="74" style={{marginTop: '-10px'}} />
              </li>
              <li className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 text-center">
                <h6><i className="material-icons" style={{fontSize: '16px'}}>location_on</i>Rosario</h6>
                <p>Corrientes 631 - Piso 6 Of. "C" - Edificio Foss II - Rosario</p>
                <p>Tel.: 0810-122-7337</p>
              </li>
            </ul>
            <hr />
            <div className="legal row">
              <div className="col-xl-9 col-lg-9 col-md-9 col-sm-8 col-12">
                <p> Pedraza Viajes y Turismo S.A. (Leg 9998) Florida 537 - 8° Piso - CABA - Bs. As - Argentina Copyright © 2018 - Todos los derechos reservados.</p>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                <a href="http://qr.afip.gob.ar/?qr=SXlWug6BABWyZtxnVo-GHg,," target="_blank" rel="noopener noreferrer"><img src={dataFiscal} alt="Data Fiscal" /></a>
                <a href="http://servicios.turismo.gob.ar/agencias/constancia/legajo/9998"  target="_blank" rel="noopener noreferrer"><img src={dataFiscal2} alt="Data Fiscal" /></a>
                <img src={iata} width="60" height="55" alt="IATA" />
              </div>
            </div>
          </div>
        </div>

        )
}

export default withRouter(SubFooter)



// WEBPACK FOOTER //
// ./src/components/Global/SubFooter.js